import { ApiPosition } from '#/api/types';
import { TPSL_ENABLED } from '#/config/constants';

import { ChartProps } from '../chartTypes';
import {
  IChartWidgetApi,
  IOrderLineAdapter,
} from '../external/charting_library';

import { NEGATIVE_COLOR, POSITIVE_COLOR } from './drawingColors';

type PositionSubset = Pick<ApiPosition, 'entryPrice' | 'quantity'>;

/** TP/SL Preview - draggable */
let tpSlOrderLine: IOrderLineAdapter | undefined;

function detectTpSlType(price: number, position: PositionSubset) {
  if (!position) {
    return;
  }
  const isLong = Number(position.quantity) > 0;
  return (isLong ? 1 : -1) * (price >= Number(position.entryPrice) ? 1 : -1) > 0
    ? 'takeProfit'
    : 'stopLoss';
}

export function resetCurrentTpSlOrderLine(
  position: PositionSubset | undefined | false
) {
  if (!position) {
    return;
  }
  tpSlOrderLine
    ?.setText(`☰ TP/SL`)
    .setBodyBackgroundColor('#000')
    .setLineColor('#AAAAAA00')
    .setPrice(Number(position?.entryPrice));
}

export function updateCurrentTpSlOrderLine(position: PositionSubset) {
  if (
    !tpSlOrderLine ||
    !position ||
    Number(tpSlOrderLine.getPrice()) === Number(position?.entryPrice)
  ) {
    return;
  }
  const newTpSlPrice = tpSlOrderLine?.getPrice();
  if (
    !newTpSlPrice ||
    !tpSlOrderLine ||
    newTpSlPrice === Number(position.entryPrice)
  ) {
    return;
  }
  const newTpSLType = detectTpSlType(newTpSlPrice, position);
  tpSlOrderLine
    .setText(`TP/SL ${newTpSLType} at price ${newTpSlPrice}`)
    .setBodyBackgroundColor(
      newTpSLType === 'takeProfit' ? POSITIVE_COLOR : NEGATIVE_COLOR
    )
    .setLineColor(
      newTpSLType === 'takeProfit' ? POSITIVE_COLOR : NEGATIVE_COLOR
    );
}

export function removeTpSlHandle() {
  tpSlOrderLine?.remove();
  tpSlOrderLine = undefined;
}

/** Drop stale adapter ref after chart widget is destroyed (skip .remove() since widget is gone) */
export function forgetTpSlOrderLine() {
  tpSlOrderLine = undefined;
}

export function renderPositionTPSLHandle(
  chart: IChartWidgetApi | undefined,
  {
    position,
    onChangeTPSLPrice,
  }: {
    position: PositionSubset | undefined;
    onChangeTPSLPrice: ChartProps['onChangeTPSLPrice'];
  },
  positionTextLength: number
) {
  if (!chart || !TPSL_ENABLED) {
    return;
  }

  removeTpSlHandle();

  if (!position) {
    // Removal only
    return;
  }

  tpSlOrderLine = chart.createOrderLine();
  resetCurrentTpSlOrderLine(position);
  tpSlOrderLine
    .setBodyBorderColor('#FFFFFFAA')
    .setBodyTextColor('#FFFFFFAA')
    .setTooltip('Drag to set TP/SL')
    .setQuantity('')
    // Move it more to the left
    .setExtendLeft(false)
    .setLineStyle(0)
    .setLineWidth(0)
    // Offset calculation, 6px = 1 chart character
    .setLineLength(-60 - positionTextLength * 6, 'pixel')
    .onMove(() => {
      console.log('[positionLines] Setting new TPSL price');
      // onSetTPSLPrice
      const newTpSlPrice = tpSlOrderLine?.getPrice();
      if (!newTpSlPrice) {
        return;
      }
      const newTpSLType = detectTpSlType(newTpSlPrice, position);
      if (newTpSLType) {
        onChangeTPSLPrice(newTpSlPrice, newTpSLType);
      }
      updateCurrentTpSlOrderLine(position);
    });
}
